import { FunnelConfig } from '~/utils/funnels';

export const COMMUNITY_HOUSING_PARTNERS_FUNNEL_ID = 'communityHousingPartners';
export const config: FunnelConfig = {
  id: COMMUNITY_HOUSING_PARTNERS_FUNNEL_ID,
  path: '/community-housing-partners',
  show: () => true,
};
